import moment from "moment";

export default class ReceiptHeaderModel {
    constructor(gcid, tagId, userId, userName, warehouseId, warehouseName){
        this.gcid = gcid;
        this.tagId = tagId;
        this.receiveDateTime = moment().format();
        this.warehouseId = warehouseId || "";
        this.warehouseName = warehouseName || "";
        this.receiverId = userId || "";
        this.receiverName = userName || "";
        this.growerId = "";
        this.growerName = "";
        this.growerRegion = "";
        this.driverId = "";
        this.driverName = "";
        this.lot = "";
        this.receiverComment = "";


        this.tagQty = 0;  


    }
}